import FileButtonOptions from './fileButtonOption';
import { useDownloadOptions } from '../../hooks/useDownloadOptions';
import { FaRegFileAlt } from 'react-icons/fa';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import AddCaseFormContext from '../../contexts/AddCaseFormContext';
import { badStatusFileError } from '../../utils/constant';
import { InfoIconTooltip } from '../ui-control/InfoIconTooltip';
import { reportItemClasses } from './listItemClasses';
import usePendingUploadPaths from '../../hooks/usePendingUploadPaths';

const FileList = ({ files = [], onRemove, isLoading = false, className = '', disabled = false, readOnly = false }) => {
    const { downloadSingleFile } = useDownloadOptions();
    const pendingUploadPaths = usePendingUploadPaths();
    const caseFormCtx = useContext(AddCaseFormContext);
    const isBadRecord = caseFormCtx?.isBadRecord ?? (() => false);
    
    const normalizeFiles = (files) => {
        if (Array.isArray(files)) return files;
        else if (files) return [files];
        else return [];
    };

    const normalizedFiles = normalizeFiles(files);

    if (normalizedFiles.length === 0) return null;

    return (
        <>
            {normalizedFiles.map((file, index) => {
                const isFileUploading = pendingUploadPaths.has(file.s3UrlPath);

                return (
                    <div key={file.s3UrlPath || file?.file?.name || index} className={`${reportItemClasses} ${className} ${isBadRecord(file.s3UrlPath) ? 'text-danger border border-danger' : ''}`}>
                        <div className="flex items-center gap-2 min-w-0 grow">
                            <FaRegFileAlt size={18} className="shrink-0" />
                            <div className="truncate">
                                {file?.name || file?.file?.name}
                            </div>
                            <InfoIconTooltip isShow={isBadRecord(file.s3UrlPath)} message={badStatusFileError} isError={true}/>
                        </div>
                        <FileButtonOptions
                            divClassName='flex items-center shrink-0'
                            onDownload={() => downloadSingleFile(file)}
                            onDelete={() => onRemove?.(file, index)}
                            isLoading={isLoading || isFileUploading}
                            isDeleteDisabled={disabled}
                            hideDelete={readOnly}
                        />
                    </div>
                );
            })}
        </>
    );
};

FileList.propTypes = {
    files: PropTypes.array,
    onRemove: PropTypes.func,
    isLoading: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
};

export default FileList;
